/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

export default
class TerrainTileAddress {
    public x: number;
    public y: number;
    public level: number;

    constructor(aX: number, aY: number, aLevel: number) {
        this.x = aX;
        this.y = aY;
        this.level = aLevel;
    }

    public atLevel(aLevel: number) {
        var floatAddress = this.atLevelFloat(aLevel);

        var flooredAddress = floatAddress;
        flooredAddress.x = Math.floor(floatAddress.x);
        flooredAddress.y = Math.floor(floatAddress.y);

        return flooredAddress;
    }

    public atLevelFloat(aLevel: number) {
        if (this.level > aLevel) {
            return new TerrainTileAddress(
                this.x / Math.pow(2.0, this.level - aLevel),
                this.y / Math.pow(2.0, this.level - aLevel),
                aLevel
            );
        } else {
            return new TerrainTileAddress(
                this.x * Math.pow(2.0, aLevel - this.level),
                this.y * Math.pow(2.0, aLevel - this.level),
                aLevel
            );
        }
    }

    public getFactorToGetAtLevel(aLevel: number) {
        return Math.pow(2.0, aLevel - this.level);
    }

    public getIndexToChildren() {
        return (this.y % 2) * 2 + (this.x % 2);
    }
}
